import React from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { Ship } from "lucide-react";

const VesselListDialog = ({ open, onClose, vessels }) => {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-md rounded bg-white p-6">
          <DialogTitle className="text-lg font-bold mb-4">
            Vessels List ({vessels.length})
          </DialogTitle>

          <div className="space-y-2">
            {vessels.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {vessels.map((vessel) => (
                  <div
                    key={vessel.vesselId}
                    className="flex items-center justify-between p-3 bg-white rounded-lg border border-gray-200 hover:border-blue-300 transition-colors"
                  >
                    <div className="flex items-center space-x-2">
                      <Ship className="h-4 w-4 text-blue-600" />
                      <span className="text-sm font-medium text-gray-800">
                        {vessel.vesselName}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center p-6 bg-gray-50 rounded-lg border border-dashed border-gray-300 text-center">
                <Ship className="h-8 w-8 text-gray-400 mb-2" />
                <p className="text-sm text-gray-500">No vessels in this fleet</p>
              </div>
            )}
          </div>

          <div className="mt-6 flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-[#1a325d] text-white rounded hover:bg-blue-900 text-sm"
            >
              Close
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default VesselListDialog;
